<template>
  <IconLucideFolderCog />
</template>
